import { TypeFromSchemaValidator } from "../../..";
import { ApiClient } from "../../../api-client";
import { ApiClientError } from "../../../errors";
import schemaValidators from "./schema-validators";
import EventEmitter from "events";

type StartAssessmentEvent = TypeFromSchemaValidator<(typeof schemaValidators)["startAssessmentEvent"]>;
type EndAssessmentEvent = TypeFromSchemaValidator<(typeof schemaValidators)["endAssessmentEvent"]>;
type EndProctoringEvent = TypeFromSchemaValidator<(typeof schemaValidators)["endProctoringEvent"]>;

export class SessionLoggerClient extends ApiClient<typeof schemaValidators> {
	readonly emitter: EventEmitter;
	constructor(config: ApiClient["config"], emitter: EventEmitter) {
		super(config, schemaValidators);
		this.emitter = emitter;
	}

	async #proctoringEvent(
		this: SessionLoggerClient,
		{
			proctoringSessionId,
			event,
		}: {
			proctoringSessionId: string;
			event: StartAssessmentEvent | EndAssessmentEvent | EndProctoringEvent;
		},
	): Promise<void> {
		try {
			this.emitter.emit("log", event);
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${proctoringSessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(event),
				credentials: "include",
			});
			if (!response.ok) {
				throw new ApiClientError(new Error(`Invalid Response: ${response.status} - ${response.statusText}`));
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
	}

	startAssessment = async ({
		proctoringSessionId,
		event,
	}: {
		proctoringSessionId: string;
		event: Pick<StartAssessmentEvent, "time" | "details">;
	}) => {
		return await this.#proctoringEvent({
			proctoringSessionId,
			event: {
				type: "session",
				name: "start quiz",
				...event,
			},
		});
	};

	endAssessment = async ({
		proctoringSessionId,
		event,
	}: {
		proctoringSessionId: string;
		event: Pick<EndAssessmentEvent, "time" | "details">;
	}) => {
		return await this.#proctoringEvent({
			proctoringSessionId,
			event: {
				type: "session",
				name: "end quiz",
				...event,
			},
		});
	};

	endProctoring = async ({
		proctoringSessionId,
		event,
	}: {
		proctoringSessionId: string;
		event: Pick<EndProctoringEvent, "time" | "details">;
	}) => {
		return await this.#proctoringEvent({
			proctoringSessionId,
			event: {
				type: "session",
				name: "end proctoring",
				...event,
			},
		});
	};
}
